var map = {
	"./sticker-A.png": 252,
	"./sticker-B.png": 253,
	"./sticker-C.png": 254,
	"./sticker-D.png": 255,
	"./sticker-E.png": 256,
	"./sticker-F.png": 257,
	"./sticker-G.png": 258,
	"./sticker-H.png": 259,
	"./sticker-I.png": 260,
	"./sticker-J.png": 261,
	"./sticker-K.png": 262,
	"./sticker-L.png": 263,
	"./sticker-M.png": 264,
	"./sticker-N.png": 265,
	"./sticker-O.png": 266,
	"./sticker-P.png": 267,
	"./sticker-Q.png": 268,
	"./sticker-R.png": 269,
	"./sticker-S.png": 270,
	"./sticker-T.png": 271,
	"./sticker-U.png": 272,
	"./sticker-V.png": 273,
	"./sticker-W.png": 274,
	"./sticker-X.png": 275,
	"./sticker-Y.png": 276,
	"./sticker-Z.png": 277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 502;